import {
  Button,
  ButtonRow,
  Checkbox,
  Col,
  InputError,
  MoreLess,
  Row,
} from '@op/opds.opux';
import { type ValidationErrors } from 'final-form';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import PageHeading from './../../components/PageHeading/PageHeading';
import styles from './LanguageConfirmation.module.scss';
import i18n from 'i18n';
import { CancelPurchaseButton } from 'individual/components/CancelPurchaseButton';
import { useAppStore } from 'state/store';
import { getInitialState, getPath } from 'utils';
import { focusFirstError } from 'utils/validators';

export default function LanguageConfirmationView() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { authenticatedCustomer, calculatorInput } = getInitialState();
  const setLanguageConfirmed = useAppStore(
    (state) => state.setLanguageConfirmed
  );
  const [confirmation, setConfirmation] = useState(false);
  const [errors, setErrors] = useState<ValidationErrors>();

  const confirmLanguage = (): void => {
    if (!confirmation) {
      setErrors({ languageConfirmation: 'required' });
    } else {
      setLanguageConfirmed(confirmation);
      const path =
        authenticatedCustomer && !!calculatorInput
          ? getPath(t('paths.insuranceContent'))
          : '/';
      navigate(path);
    }
  };

  useEffect(() => {
    if (errors) focusFirstError(errors);
  }, [errors]);

  return (
    <Row center data-testid='lifepurchase-language-confirmation'>
      <Col
        id='lifepurchase-language-confirmation'
        className='opds App opds-styles-v1-elements center'>
        <div className={styles.customHeaders}>
          <PageHeading title={i18n.t('common.opLifeInsurance')} />
          <div className={styles.insetBlock}>
            <h2>{i18n.t('confirmServiceLanguage.title')}</h2>
            <p>{i18n.t('confirmServiceLanguage.body')}</p>
            <MoreLess
              messages={{
                more: i18n.t('confirmServiceLanguage.readMore'),
                less: i18n.t('confirmServiceLanguage.readLess'),
              }}>
              <h3>{i18n.t('confirmServiceLanguage.infoSubtitle')}</h3>
              <p>{i18n.t('confirmServiceLanguage.infoText')}</p>
              <p>{i18n.t('confirmServiceLanguage.infoText2')}</p>
            </MoreLess>
            <Checkbox
              id='languageConfirmation'
              labelProps={{
                'data-testid': 'languageConfirmation',
              }}
              required
              invalid={!!errors}
              tabIndex={0}
              onChange={(ev, val) => {
                setConfirmation(val);
              }}>
              {i18n.t('confirmServiceLanguage.checkboxLabel')}
            </Checkbox>
            <InputError
              error={
                errors ? i18n.t('confirmServiceLanguage.required') : undefined
              }
            />
            <ButtonRow>
              <Button
                primary
                onClick={confirmLanguage}
                data-testid='language-confirm-continue-button'>
                {i18n.t('background.form.continue')}
              </Button>
              <CancelPurchaseButton />
            </ButtonRow>
          </div>
        </div>
      </Col>
    </Row>
  );
}
